<template>
  <el-dialog v-model="dialogVisible" width="500" :before-close="handleClose" class="collection-handle-check-dialog" :key="dialogVisible">
    <template #header>
      <h3>{{ title }} </h3>
      <el-select v-model="flagValue" placeholder="Select" popper-class="flag-list-select" v-if="openId === 3">
        <template #label="{ label, value }">
          <div class="flex">
            <svg-icon :class="[`svg-flag-${value.color}`]" name="flag-color" />
            <span>{{ label }} </span>
          </div>
        </template>
        <el-option v-for="item in flagList.filter(e => e.show)" :key="item.id" :label="item.text" :value="item">
          <div class="flex">
            <svg-icon :class="[`svg-flag-${item.color}`]" name="flag-color" />
            <span>{{ item.text }}</span>
          </div>
        </el-option>
      </el-select>
    </template>

    <div class="content-box">

      <div class="collection-status-alert-box" v-if="data.length > 1">
        <h3><svg-icon name="warning" />Summary</h3>
        <p>Total selected: {{ data.length }} {{ whichType }}(s)</p>
        <p v-if="openId === 1">
          {{ whichTypeTitle }}(s) will be disabled: {{data.filter(e => e.is_active ).length}} {{ whichType }}(s)
          <!-- Already {{ !disabledCheckbox ? `disabled` : `archvied` }} (will be skipped): {{ !disabledCheckbox ? skipLength70 : skipLength65}}
          {{ whichType }}(s) -->
        </p>

        <p v-if="openId === 2 || openId === 5">
          {{ whichTypeTitle }}(s) will be reactivate: {{ data.length - nowActive.length }} {{ whichType }}(s)<br />
          <!-- Already reactivate (will be skipped): {{ nowActive.length }} {{ whichType }}(s) -->
        </p>

        <p v-if="openId === 3">
          {{ whichTypeTitle }}(s) will be flag: {{ canChangeFlagList.length }} {{ whichType }}(s)<br />
          <!-- Already flagged as {{ flagValue.text }} (will be skipped): {{ data.length - canChangeFlagList.length }}
          {{ whichType }}(s) -->
        </p>

      </div>

      <label>{{ smallValue.label }}<span class="alert">*</span></label>
      <el-input v-model="reasonValue" maxlength="1000" :placeholder="smallValue.placeholder" show-word-limit
        type="textarea" resize="none" />

      <div class="checkbox-box" v-if="openId === 1">
        <Checkbox :label_text="'Allow creator to make changes'" :checked="disabledCheckbox"
          @click="handleDisabledCheckFunction();" :disabled="all65 || all70" />
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="openSmallDialog();" :disabled="!reasonValue">
          {{ smallValue.btn }}
        </el-button>
      </div>
    </template>
  </el-dialog>


  <el-dialog v-model="smallDialogVisible" :title="smallDialogContent.title" :width="data.length >1 ? 500: 300" :show-close="false"
    @close="closeSmallDialog()">
    <div class="collection-status-alert-box" v-if="data.length > 1" style="margin-bottom: 16px;">
      <h3><svg-icon name="warning" />Summary</h3>
      <p>Total selected: {{ data.length }} {{ whichType }}(s)</p>
      <p v-if="openId === 1">
        {{ whichTypeTitle }}(s) will be disabled: {{data.filter(e => e.is_active ).length}} {{ whichType }}(s)
        <br/>Already disabled (will be skipped): {{ Number(skipLength70) + Number(skipLength65) }}{{ whichType }}(s)
      </p>
      <p v-if="openId === 2 || openId === 5">
        {{ whichTypeTitle }}(s) will be reactivate: {{ data.length - nowActive.length }} {{ whichType }}(s)<br />
        Already reactivate (will be skipped): {{ nowActive.length }} {{ whichType }}(s)
      </p>

      <p v-if="openId === 3">
        {{ whichTypeTitle }}(s) will be flag: {{ canChangeFlagList.length }} {{ whichType }}(s)<br />
        Already flagged as {{ flagValue.text }} (will be skipped): {{ data.length - canChangeFlagList.length }}
        {{ whichType }}(s)
      </p>

    </div>
    <span>{{ smallDialogContent.content }}</span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeSmallDialog();">Cancel</el-button>
        <el-button type="primary" @click="callAPi();">
          Confirm
        </el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog v-model="doubleCheckReactiveDialog" :title="smallDialogContentList.doubleCheckReactive.title" width="300" :show-close="false"
    @close="closeSmallDialog()">
    <span>{{ smallDialogContentList.doubleCheckReactive.content }}</span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="callAPi('onlyFlag');">Cancel</el-button>
        <el-button type="primary" @click="callAPi('doubleConfirm');">
          Reactivate
        </el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog v-model="handleDialog" :title="handleDialogContent.title" width="300" :show-close="false"
    @close="closeSmallDialog();handleDialog=false;">
    <span>{{ handleDialogContent.content }}</span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeSmallDialog();handleDialog=false">Cancel</el-button>
        <el-button type="primary" @click="dialogVisible=true">
          Confirm
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>

import { ref, getCurrentInstance, onMounted, computed, onBeforeUnmount ,watch } from 'vue';
import { useStore } from 'vuex';
import { ElDialog, ElButton, ElInput, ElSelect, ElOption } from 'element-plus';
import Checkbox from '@/components/ui/Checkbox.vue';
import { useNotification } from '@/components/ui/notification';
import { useCollectionFilter } from '@/components/creator/collectionFilterFunction.js';


const store = useStore();
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const { openNotBottom, openNotEmailBottom } = useNotification();
const { callApiTypeId, makeCollectionItem  } = useCollectionFilter();

const eventBus = app.appContext.config.globalProperties.EventBus;
const dialogVisible = ref(false);
const openId = ref(1); // 1: Disable, 2: Reactive, 3: Flag Content, 4: Resolve a Flag
const data = ref([]);
const reasonValue = ref('');
const handleReasonValue = ref('');
const whichType = ref('post'); // post, collection
const creatorName = ref('');
const is_sending = ref(false);

const disabledCheckbox = ref(false);
//100=high 50=meduim 10=low 0=none
const flagList = ref([
  { id: 1, text: 'Low', color: 'blue', show: true, value: 10 },
  { id: 2, text: 'Medium', color: 'yellow', show: true, value: 50 },
  { id: 3, text: 'High', color: 'red', show: true, value: 100 },
  { id: 4, text: 'None', color: 'red', show: false, value: 0 },
]);
const flagValue = ref({ id: 3, text: 'High', color: 'red', value: 100 });

const whichTypeTitle = computed(() => {
  if (whichType.value === 'post') {
    return 'Post';
  } else if (whichType.value === 'collection') {
    return 'Collection';
  } else {
    return '';
  }
});

const title = computed(() => {
  if (openId.value === 1) {
    
    if(data.value.length > 1){
      return `Disable These ${whichTypeTitle.value}s`;
    }else{
      return `Disable This ${whichTypeTitle.value}`;
    }

  } else if (openId.value === 2 || openId.value === 5) {
    return `Reactivate This ${whichTypeTitle.value}`;
  } else if (openId.value === 3) {
    return 'Flag Content';
  } else if (openId.value === 4) {
    return 'Resolve a Flag';
  } else {
    return '';
  }
});

const smallValue = computed(() => {
  if (openId.value === 1) {
    return {
      label: 'Reason',
      btn: 'Disable and send',
      placeholder: `Explain why you’re changing this ${whichType.value}’s status.`,
    }
  } else if (openId.value === 2 || openId.value === 5) {
    return {
      label: 'Reason',
      btn: 'Reactivate and send',
      placeholder: `Explain why you’re changing this ${whichType.value}’s status.`,
    }
  } else if (openId.value === 3) {
    return {
      label: 'Comment',
      btn: 'Confirm & send',
      placeholder: `Explain why you’re changing this ${whichType.value}’s status.`,
    }
  } else if (openId.value === 4) {
    return {
      label: 'Comment',
      btn: 'Confirm & send',
      placeholder: `Explain why you’re changing this ${whichType.value}’s status.`,
    }
  } else {
    return '';
  }
});

const handleDialog=ref(false);  
const handleDialogContent = ref({ title: '', content: '' });

const nowDisabled = computed(() => {
  return data.value.filter(e => e.is_disabled || e.is_hidden || e.is_archvied);
});

const nowActive = computed(() => {
  return data.value.filter(e => e.is_active);
});

const all65 = computed(() => {
  return data.value.length === nowDisabled.value.filter(e => e.is_archvied).length;
});

const skipLength65 = computed(() => {
  return nowDisabled.value.filter(e => e.is_archvied ).length;
});

const all70 = computed(() => {
  return data.value.length === nowDisabled.value.filter(e => e.is_disabled ).length;
});

const skipLength70 = computed(() => {
  return nowDisabled.value.filter(e => e.is_disabled ).length;
});

const canChangeFlagList = computed(() => {
  return data.value.filter(e => e.contentModertaion.flag_status !== flagValue.value.value);
});

const canResloveFlagList = computed(() => {
  return data.value.filter(e => !e.contentModertaion.flag_status);
});

const smallDialogVisible = ref(false);
const smallDialogContent = ref({ title: '', content: '' });
const smallDialogContentList = computed(() => {
  return {
    disabled1: {
      title: `Are you sure want to disable this ${whichType.value}?`,
      content: `This message will be sent to the creator’s chat, and the ${whichType.value} will no longer appear in their storefront until you reactivate it. The creator can still edit the ${whichType.value} while it’s disabled.`
    },
    disabled2: {
      title: `Are you sure want to disable this ${whichType.value}?`,
      content: `This message will be sent to the creator’s chat, and the ${whichType.value} will no longer appear in their storefront until you reactivate it. The creator cannot edit the ${whichType.value} while it’s disabled.`
    },
    reactive1: {
      title: `Are you sure want to reactivate this ${whichType.value}?`,
      content: `The creator will receive this message in their Creator Portal, and the ${whichType.value} will reappear in their storefront.`
    },
    resolveFlag: {
      title: `Are you sure want to resolve this flag?`,
      content: `Resolving this flag will remove it from the ${whichType.value} in their portal.`
    },
    doubleCheckReactive: {
      title: `Do you also want to reactivate this disabled ${whichType.value}?`,
      content: `Once you resolve this flag, you can also reactivate the disabled ${whichType.value} so it will reppear in the creator’s storefront.`
    },
  }
});

const permission_mes = computed(() => {
  return store.state.user_data?.permission_list?.messagesAndAnnouncements;
});

const canNotChatWithCreator = computed(() => {
  return permission_mes.value?.manageMessaging?.permission !== 100;
});

const doubleCheckReactiveDialog = ref(false);
//++++++++++++++++++++++++++++++++++++++
//++++++++++++++++++++++++++++++++++++++
const open = (getdata) => {
  openId.value = getdata.id;
  data.value = getdata.rows;
  whichType.value = getdata.which
  creatorName.value = data.value[0].anchor_creator.first_name + ' ' + data.value[0].anchor_creator.last_name;
  reset();

  if(data.value.length > 1){

    let num = 0;
    let target='';
    switch(openId.value){
      case 1:
        num = nowDisabled.value.length;
        target = 'disabled';
        break;
      case 2:
        num= nowActive.value.length;
        target = 'reactivated';
        break;
      case 3:
        num= data.value.length - canChangeFlagList.value.length;
        target = 'flagged';
        break;
    }
    if(num){
      handleDialogContent.value = {
        title: `${num} ${whichType.value}(s) are already ${target}`,
        content: `${num} ${whichType.value}(s) will not be included in your next step.`
      };
      handleDialog.value = true;
    }else{
      dialogVisible.value = true;
    }
  }else{
    dialogVisible.value = true;
  }

  
};

const handleOpenAgain = () => {
  let getdata={
    id: 5,//rember to call case 4 and 2
    rows: data.value,
    which: whichType.value,
  }
  open(getdata);
};

const handleClose = () => {
  dialogVisible.value = false;
  reset();
};

const updateFlagListVisibility = () => {
  if (!data.value.length) return;

  // all flag_status
  const allFlagStatuses = data.value.map(e => e.contentModertaion.flag_status);
  flagList.value.forEach(flag => {
    if (flag.value === 0) {
      flag.show = false;
    } else {
      // 檢查是不是所有 flag_status 都等於這個值
      const allSame = allFlagStatuses.every(status => status === flag.value);
      flag.show = !allSame;
    }
  });
};

const reset = () => {
  reasonValue.value = '';
  if (openId.value === 3) {
    updateFlagListVisibility();
    flagValue.value = flagList.value.some(e => e.value === 100 && e.show) ? flagList.value.find(e => e.value === 100) : flagList.value[0]; // default to High

  } else if (openId.value === 4) {
    flagValue.value = flagList.value.find(e => e.value === 0); // default to None
  }

  setTimeout(() => {
    disabledCheckbox.value = all65.value ? false : all70.value ? true : false; // default value
  }, 10);
};

const handleDisabledCheckFunction = () => {

  if (all65.value) {
    disabledCheckbox.value = false; // can not be ture if there is hidden content
  } else if (all70.value) {
    disabledCheckbox.value = true; // can not be false if there is disabled content
  } else {
    disabledCheckbox.value = !disabledCheckbox.value; // toggle
  }
};

const openSmallDialog = () => {
  if (openId.value === 1 && disabledCheckbox.value) {
    smallDialogContent.value = smallDialogContentList.value.disabled1;
  } else if (openId.value === 1) {
    smallDialogContent.value = smallDialogContentList.value.disabled2;
  } else if (openId.value === 2 ) {
    smallDialogContent.value = smallDialogContentList.value.reactive1;
  } else if (openId.value === 4) {
    smallDialogContent.value = smallDialogContentList.value.resolveFlag;
  } 
  else {
    callAPi();
    return;
  }

  smallDialogVisible.value = true;
};

const closeSmallDialog = () => {
  smallDialogVisible.value = false;
  smallDialogContent.value = { title: '', content: '' };
  handleDialog.value = false;
};


const callAPi = async (val) => {
  try {
    if (openId.value === 4 && (data.value[0]?.is_disabled || data.value[0]?.is_archvied)) {
      if (!val) {
        doubleCheckReactiveDialog.value = true;
        return;
      }
      doubleCheckReactiveDialog.value = false;

      if (val === "onlyFlag") {
        await handleResolveFlag();
      } else if (val === "doubleConfirm") {
        handleReasonValue.value = reasonValue.value;
        handleOpenAgain();
      };
    } else {
      switch (openId.value) {
        case 1: await handleDisable(); break;
        case 2: await handleReactive(); break;
        case 3: await handleFlagContent(); break;
        case 4: await handleResolveFlag(); break;
        case 5: await handleResolveFlag('handle'); await handleReactive(); break;
      }
    }
  } catch (err) {
    console.log('err',err)
    let errMes = err.response?.data?.message || "Something went wrong.";
    openNotBottom(errMes, "error");
  } finally {
    if((openId.value === 4 && (data.value[0]?.is_disabled || data.value[0]?.is_archvied) && !val )|| val === "doubleConfirm"){
      return;
    }
    dialogVisible.value = false;
    closeSmallDialog();
  }
};

/* ---- API handlers ---- */
const handleDisable = async () => {
  if (is_sending.value) return;

  const form = new FormData();
  form.append("reason", reasonValue.value);
  form.append("content_type", callApiTypeId(whichType.value));

  const statusId = disabledCheckbox.value ? 65 : 70;
  form.append("status", statusId);

  let nowData = nowDisabled.value.filter(e =>
    disabledCheckbox.value ? e.is_disabled : e.is_hidden
  );
  [...nowData, ...nowActive.value].forEach(e =>
    form.append("content_ids[]", e.id)
  );

  is_sending.value = true;

  const res = await ajax.post("/creator/update-content-status", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  is_sending.value = false;

  const da = res.data.data;
  const allDataLength = da.update_success_list.length + da.update_fail_list.length;
  const title1 =
    allDataLength > 1
      ? `${da.update_success_list.length} ${whichTypeTitle.value === 'Post' ? 'posts' : 'collections'} were successfully disabled`
      : `${whichTypeTitle.value} disabled successfully`;

  if (da.update_success_list.length) {
    if (canNotChatWithCreator.value) {
      openNotEmailBottom(
        title1,
        `${whichTypeTitle.value}(s) disabled successfully, but upgrade required for creator chat function.`,
        `Contact sales`,
        `success`
      );
    } else {
      openNotEmailBottom(title1, `Disabled content and sent to creator chat.`, ``, `success`);
    }
  }

  const customClass = da.update_success_list.length
    ? "custom-error-notification offset-up"
    : "custom-error-notification";

  if (da.update_fail_list.length) {
    const title2 =
      allDataLength > 1
        ? `${da.update_fail_list.length} post(s) disabled unsuccessfully`
        : `${whichTypeTitle.value} disabled unsuccessfully`;
    openNotEmailBottom(title2, ``, `Send email`, `error`, customClass);
  }

  handleRefrash(da.content_moderation_list[0]);
};

const handleRefrash = (val) => {
  console.log('val',val)
  console.log('data.value',data.value)
  if(data.value.length === 1 && val){
    data.value[0].contentModertaion = val;
    makeCollectionItem(data.value[0]); 
    window.localStorage.setItem('handleRowDataFromCollection', JSON.stringify(data.value[0]));
    console.log('data.value[0]',data.value[0])
    eventBus.emit("refrash-collection-product", data.value[0]);
  }
  eventBus.emit("refrash-collection-table");
};

const handleReactive = async () => {
  if (is_sending.value) return;

  const form = new FormData();
  form.append("reason", reasonValue.value);
  form.append("content_type", callApiTypeId(whichType.value));
  form.append("status", 100);

  nowDisabled.value.forEach(e => form.append("content_ids[]", e.id));
  is_sending.value = true;
  const res = await ajax.post("/creator/update-content-status", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  is_sending.value = false;

  const da = res.data.data;
  const allDataLength = da.update_success_list.length + da.update_fail_list.length;
  const title3 =
    allDataLength > 1
      ? `${da.update_success_list.length} ${whichTypeTitle.value === 'Post' ? 'posts' : 'collections'} reactivated successfully`
      : `${whichTypeTitle.value} reactivated successfully.`;

  if (da.update_success_list.length) {
    if (canNotChatWithCreator.value) {
      openNotEmailBottom(
        title3,
        `Reactivated ${whichTypeTitle.value === 'Post' ? 'post' : 'collection'} successfully, but upgrade required for creator chat function.`,
        `Contact sales`,
        `success`
      );
    } else {
      openNotEmailBottom(
        title3,
        `Reactivated ${whichTypeTitle.value === 'Post' ? 'post' : 'collection'} successfully and sent to creator chat.`,
        ``,
        `success`
      );
    }
  }

  const customClass = da.update_success_list.length
    ? "custom-error-notification offset-up"
    : "custom-error-notification";

  if (da.update_fail_list.length) {
    const title4 =
      allDataLength > 1
        ? `${da.update_fail_list.length}  ${whichTypeTitle.value === 'Post' ? 'post' : 'collection'}(s) reactivated unsuccessfully`
        : `Reactivated unsuccessfully`;
    openNotEmailBottom(
      title4,
      `Reactivated ${whichTypeTitle.value === 'Post' ? 'post' : 'collection'} unsuccessfully because creator chat is disabled.`,
      `Send email`,
      `error`,
      customClass
    );
  }

  handleRefrash(da.content_moderation_list[0]);
};

const handleFlagContent = async () => {
  const form = new FormData();
  form.append("reason", reasonValue.value);
  form.append("content_type", callApiTypeId(whichType.value));
  canChangeFlagList.value.forEach(e => form.append("content_ids[]", e.id));
  form.append("flag_status", flagValue.value.value);

  const res = await ajax.post("/creator/update-content-flag", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  const da = res.data.data;
  const allDataLength = da.update_success_list.length + da.update_fail_list.length;
  const title4 =
    allDataLength > 1
      ? `${da.update_success_list.length} of ${whichType.value} flagged successfully`
      : `${whichTypeTitle.value} flagged successfully`;

  if (da.update_success_list.length) {
    if (canNotChatWithCreator.value) {
      openNotEmailBottom(
        title4,
        `Flagged ${whichType.value}(s), but upgrade required for creator chat function.`,
        `Contact sales`,
        `success`
      );
    } else {
      openNotEmailBottom(title4, `Flagged ${whichType.value}(s) and sent to creator chat.`, "", `success`);
    }
  }

  const customClass = da.update_success_list.length
    ? "custom-error-notification offset-up"
    : "custom-error-notification";

  if (da.update_fail_list.length) {
    const title5 =
      allDataLength > 1
        ? `${da.update_fail_list.length} ${whichType.value}(s) flagged and sent unsuccessfully`
        : `${whichTypeTitle.value} flagged and sent unsuccessfully`;
    openNotEmailBottom(title5, ``, `Send email`, `error`, customClass);
  }

  handleRefrash(da.content_moderation_list[0]);
};

const handleResolveFlag = async (val) => {
  const form = new FormData();
  if(val === 'handle'){
    form.append("reason", handleReasonValue.value);
  }else{
    form.append("reason", reasonValue.value);
  }
  form.append("content_type", callApiTypeId(whichType.value));
  canChangeFlagList.value.forEach(e => form.append("content_ids[]", e.id));
  form.append("flag_status", 0);

  const res = await ajax.post("/creator/update-content-flag", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  const da = res.data.data;
  const allDataLength = da.update_success_list.length + da.update_fail_list.length;
  const title6 =
    allDataLength > 1
      ? `${da.update_success_list.length} of ${whichType.value} flagged resolved and sent successfully.`
      : `Resolved and sent successfully`;

  if (da.update_success_list.length) {
    if (canNotChatWithCreator.value) {
      openNotEmailBottom(
        title6,
        `Resolved ${whichType.value}(s), but upgrade required for creator chat function.`,
        `Contact sales`,
        `success`
      );
    } else {
      openNotEmailBottom(title6, `Resolved ${whichType.value}(s) and sent to creator chat.`, "", `success`);
    }
  }

  const customClass = da.update_success_list.length
    ? "custom-error-notification offset-up"
    : "custom-error-notification";

  if (da.update_fail_list.length) {
    const title7 =
      allDataLength > 1
        ? `${da.update_fail_list.length} of ${whichType.value}(s) resolved failed`
        : `${whichTypeTitle.value} resolved failed`;
    openNotEmailBottom(title7, ``, `Send email`, `error`, customClass);
  }

  handleRefrash(da.content_moderation_list[0]);
};



onMounted(() => {
  eventBus.on('open-collection-handle-dialog', (data) => {
    open(data);
  });
});

onBeforeUnmount(() => {
  eventBus.off('open-collection-handle-dialog');
});

</script>

<style lang="scss">
.collection-handle-check-dialog {
  .flex {
    display: flex;
    align-items: center;
  }

  .svg-icon--flag-color {
    width: 16px;
    height: 16px;
  }

  .el-dialog__header {
    display: flex;
    gap: 16px;

    i {
      margin-top: 16px;
    }

    h3 {
      flex: 1;
    }

    .el-select {
      width: 140px;

      .flex {
        display: flex;
        justify-content: flex-start;
        gap: 16px;
        align-items: center;
      }

      .el-select__suffix {
        .el-icon {
          width: 12px;
          margin: 0;
        }
      }
    }
  }

  .content-box {
    display: flex;
    flex-direction: column;
    gap: 16px;

    label {
      font-weight: 600;
      font-size: 14px;
      color: var(--black-90);

      .alert {
        color: var(--red); // 紅色星號
        margin-left: 4px;
      }
    }
    .el-textarea__inner {
      min-height: 120px !important;
      font-size: 14px;
      border-radius: 6px;
    }


    .ui-checkbox {
      margin: 0;
    }
  }
}

.flag-list-select {
  width: 140px;

  .svg-icon--flag-color {
    width: 16px;
    height: 16px;
  }

  li .flex {
    justify-content: flex-start;
    gap: 16px;
    display: flex;
    align-items: center;
  }
}

.collection-status-alert-box {
  background-color: var(--bg-02);
  padding: 16px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.5;

  h3 {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    font: var(--font-med-16);

    svg {
      width: 14px;
      height: 14px;
    }
  }

  p {
    font-size: 12px;
  }
}
</style>